import { useTranslation } from 'react-i18next';
import UniversalButton from "components/uiComponents/UniversalButton";
import { ReactComponent as PlusCircleIcon } from "static/icons/plus-circle.svg";
import "./AdvanceFiltersContent.scss";
import useSetting from "../SidebarProject/use-settings";
import { ItemsTypeEnum } from "store/reducers/viewerReducer";
import SettingsItem from "../SettingItem/SettingItem";

const AdvanceFiltersContent = () => {
  const { t } = useTranslation();

  const { settingsItems, addFilterItemHandler, deleteItemsHandler } = useSetting();
  const currentFilters = settingsItems?.filters ?? []

  const deleteFilterHandler = (filterId) => {
    deleteItemsHandler(filterId, ItemsTypeEnum.filters)
  }

  const addNewFilterHandler = () => {
    addFilterItemHandler()
  };

  return (
    <div className="color-content">
      <div className="items-wrapper">
        {
          currentFilters ? currentFilters.map((settingsItem) => {

            return <SettingsItem
              key={settingsItem.id}
              id={settingsItem.id}
              currentOption={settingsItem.selectedOption}
              inputsDataArray={settingsItem.inputsDataArray}
              deleteItemCallback={deleteFilterHandler}
              type={ItemsTypeEnum.filters}
              options={settingsItem.options}
            />
          })
            : null
        }
      </div>
      <UniversalButton
        leftIcon={<PlusCircleIcon />}
        labelColor="blue"
        onClick={addNewFilterHandler}
        backgroundHoverColor="blue-light"
        backgroundColor="blue"
        isFullWidth
        label={t('add_condition')}
      />
    </div>
  );
};

export default AdvanceFiltersContent;
